/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Television(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M216,64H147.31445l34.34278-34.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L128,60.68652,85.65723,18.34277A8.00053,8.00053,0,0,0,74.34277,29.65723L108.68555,64H40A16.01833,16.01833,0,0,0,24,80V200a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V80A16.01833,16.01833,0,0,0,216,64Zm0,136H160V80h56l.00977,120Zm-16-84a12,12,0,1,1-12-12A12,12,0,0,1,200,116Zm0,48a12,12,0,1,1-12-12A12,12,0,0,1,200,164Z" />
    </Svg>
  );
}

export default Television;
